<div class="availability-container" *ngIf="productItem">
  <div class="availability-description">
    <p>
      By default, once you publish this product, it will be available at all your
      locations. If you would like to restrict the availability of this product to certain
      locations or Location groups, you can do so by adding exclusions below.
    </p>
  </div>

  <div class="excluded-locations-count">
    <span class="count-text">{{ excludedStores.length }} location added</span>
  </div>

  <div class="excluded-stores-chips" *ngIf="excludedStores.length > 0">
    <mat-chip-listbox>
      <mat-chip *ngFor="let store of excludedStores" selected>
        {{ store }}
      </mat-chip>
    </mat-chip-listbox>
  </div>
</div>
